import './css/style.scss'

document.addEventListener('DOMContentLoaded', () => {
    const overlays = document.querySelectorAll('.overlay');
    const openOverlays = document.querySelectorAll('.open-overlay .schleife-text');
    const maxPages = Array.from(overlays).reduce((acc, el) => {
        const page = +el.classList.value.match(/page-(\d)/)[1];
        return page > acc ? page : acc;
    }, 0)

    const activatePage = page => {
        Array.from(overlays).find(overlay => overlay.classList.contains(page)).classList.add('active');
        document.querySelector(`.${page}.open-overlay .schleife-text`).classList.add('active');
    }

    document.addEventListener('click', event => {
        const overlay = event.target.closest('.overlay')
        if (!overlay) {
            overlays.forEach(overlay => overlay.classList.remove('active'));
            openOverlays.forEach(text => text.classList.remove('active'));
        } else if (event.target.classList.contains('icon-x')) {
            overlay.classList.remove('active');
            openOverlays.forEach(text => text.classList.remove('active'));
            return;
        } else if (event.target.classList.contains('icon-chevron-left')) {
            const page = +overlay.classList.value.match(/page-(\d)/)[1];
            const newPage = page === 1 ? maxPages : page - 1
            overlay.classList.remove('active');
            openOverlays.forEach(text => text.classList.remove('active'));
            activatePage('page-' + newPage);
        } else if (event.target.classList.contains('icon-chevron-right')) {
            const page = +overlay.classList.value.match(/page-(\d)/)[1];
            const newPage = page === maxPages ? 1 : page + 1
            overlay.classList.remove('active');
            openOverlays.forEach(text => text.classList.remove('active'));
            activatePage('page-' + newPage);
        }

        const openOverlay = event.target.closest('.open-overlay');
        if (openOverlay) {
            const page = openOverlay.classList.value.match(/page-\d/)[0];
            activatePage(page)
        }
    })
})